import React from 'react';
import Svg, { Path } from 'react-native-svg';
var SVGComponent = function SVGComponent(props) {
  var style = props.style;
  return /*#__PURE__*/React.createElement(Svg, {
    style: style,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M7.75 9.25V16.5H9.25V9.25H16.5V7.75H9.25V0.5H7.75V7.75H0.5V9.25H7.75Z",
    fill: "black",
    fillOpacity: "0.65"
  }));
};
export default SVGComponent;